/**
 * 🔒 Безопасная загрузка медиафайлов с Authorization заголовком
 * Вместо передачи токена в URL (?token=...), используем заголовок Authorization
 */

import api from '../services/api';

// Кеш для blob URLs, чтобы не загружать изображения повторно
const blobUrlCache = new Map();

/**
 * Загружает медиафайл с Authorization заголовком и возвращает blob URL
 * @param {string} fileId - ID файла в VK ORD
 * @returns {Promise<string>} - blob URL для использования в <img src>
 */
export async function getSecureMediaUrl(fileId) {
  // Проверяем кеш
  if (blobUrlCache.has(fileId)) {
    return blobUrlCache.get(fileId);
  }

  try {
    // ✅ БЕЗОПАСНО: Загружаем через fetch с Authorization заголовком
    const response = await api.get(`/media/vk-ord/${fileId}`, {
      responseType: 'blob' // Получаем как blob
    });

    // Создаём blob URL
    const blob = response.data;
    const blobUrl = URL.createObjectURL(blob);

    // Сохраняем в кеш
    blobUrlCache.set(fileId, blobUrl);

    return blobUrl;
  } catch (error) {
    console.error(`Ошибка загрузки медиафайла ${fileId}:`, error);
    throw error;
  }
}

/**
 * Очищает кеш blob URLs (освобождает память)
 * Вызывать при размонтировании компонента или закрытии модального окна
 */
export function clearMediaCache() {
  // Освобождаем blob URLs
  for (const blobUrl of blobUrlCache.values()) {
    URL.revokeObjectURL(blobUrl);
  }
  blobUrlCache.clear();
}

/**
 * Очищает конкретный blob URL из кеша
 * @param {string} fileId - ID файла
 */
export function revokeMediaUrl(fileId) {
  const blobUrl = blobUrlCache.get(fileId);
  if (blobUrl) {
    URL.revokeObjectURL(blobUrl);
    blobUrlCache.delete(fileId);
  }
}

// React Hook удалён - используем прямые вызовы getSecureMediaUrl() в компонентах

